import { useQuery } from '@tanstack/react-query';
import { getAccessRangeForRoles } from 'api/accessRangeForRoles';
import { accessRangeForRolesKeys } from 'api/queryKeys';
import { useMainCompanyQuery } from './useMainCompanyQuery';

export const useAccessRangeForRolesQuery = () => {
  const { data: mainCompany } = useMainCompanyQuery();
  const companyId = mainCompany?.id ?? '';

  return useQuery({
    queryKey: accessRangeForRolesKeys.list(companyId),
    queryFn: () =>
      getAccessRangeForRoles(companyId).then((res) => {
        const raw = res.data;
        return Array.isArray(raw) ? raw : undefined;
      }),
    enabled: !!companyId
  });
};
